import { httpClient_PCP, httpClient_ANALYTIC_LOGIN } from "./httpClient";

const Login = payload =>
  httpClient_ANALYTIC_LOGIN.post("/post/pca_login", {
    username: payload.username,
    password: payload.password,
    is_ys: payload.is_ys ? payload.is_ys : false
  });
const YSLogin = payload =>
  httpClient_ANALYTIC_LOGIN.post("/post/ys_login", {
    ys_token: payload.token
  });

export { Login, YSLogin };
